import { Fragment } from 'react';

import { SearchableVendorTaxonomyKey } from '@zola-helpers/client/dist/es/marketplace';
import { Title2, Title3 } from '@zola/zola-ui/src/typography/Headings';

import cx from 'classnames';

import { getFaqSchema, renderSchemas } from '~/util/seoUtils';

import VendorsFAQ from '../../../meta/CategoryFaqs';
import { PageSection } from '../../PageSection/PageSection';

import styles from './faqSection.module.less';

export const getVendorTypeFAQ = (vendorType: SearchableVendorTaxonomyKey) => {
  return VendorsFAQ[vendorType];
};

interface FaqSectionProps {
  className?: string;
  vendorType: SearchableVendorTaxonomyKey;
}

export const FaqSection = ({ className, vendorType }: FaqSectionProps) => {
  const { content } = getVendorTypeFAQ(vendorType);
  const schemas = [getFaqSchema(content)];

  return (
    <PageSection contentClassName={cx(styles.faqSection, className)}>
      <div className={styles.container}>
        {renderSchemas(schemas)}
        <div className={styles.content}>
          <Title2 className={styles.title} presentation="h3">
            Frequently asked questions
          </Title2>
          <div>
            {content.map(({ question, answer }, i) => (
              <Fragment key={i}>
                <Title3 className={styles.question} presentation="h5">
                  {question}
                </Title3>
                {/* eslint-disable-next-line react/no-danger */}
                <div className={styles.answer} dangerouslySetInnerHTML={{ __html: answer }} />
              </Fragment>
            ))}
          </div>
        </div>
      </div>
    </PageSection>
  );
};
